export default "__VITE_ASSET__J2t$LHQu__"